export const MAP_MOVE = 'MAP_MOVE'

/**
 * User moved the center of the map viewport.
 * @param {import('@bikemap/js/map').LngLat} center
 */
export const mapMove = center => ({
    type: MAP_MOVE,
    payload: {
        center,
    },
})

export const MAP_ZOOM = 'MAP_ZOOM'

/**
 * User changed zoom level of the map viewport.
 * @param {number} zoom
 */
export const mapZoom = zoom => ({
    type: MAP_ZOOM,
    payload: {
        zoom,
    },
})

export const MAP_BOUNDS_UPDATE = 'MAP_BOUNDS_UPDATE'

/**
 * Map bounds changed.
 * @param {import('@bikemap/js/map').LngLatBounds} bounds
 */
export const mapBoundsUpdate = bounds => ({
    type: MAP_BOUNDS_UPDATE,
    payload: {
        bounds,
    },
})

export const SET_MAP_VIEWPORT = 'SET_MAP_VIEWPORT'

/**
 * Map viewport is set by the app.
 * @param {{ center?: import('@bikemap/js/map').LngLat, zoom?: number }} viewport
 */
export const setMapViewport = viewport => ({
    type: SET_MAP_VIEWPORT,
    payload: {
        viewport,
    },
})
